import React, { useEffect, useState } from 'react';

const Skill = ({ language }) => {
    const [animation, setAnimation] = useState(0);

    useEffect(() => {
        const intervalId = setInterval(function () {
            if (intervalId) {
                clearInterval(intervalId);
            };
            if (animation < 100) {
                setAnimation(animation + 1);
            };
        }, 10);
    }, [animation]);

    const { name, skill } = language;

    return (
        <div className='w-44 h-36 shadow-md shadow-green-700 pt-5 pb-2 rounded-xl relative scale-75  bg-[#ffffff10]'>
            {/* <div className='w-44 h-36 shadow-md shadow-amber-600 pt-5 pb-2 rounded-xl relative scale-75  bg-[#ffffff10]'> */}
            {/* <div className='w-44 h-36 shadow shadow-sky-500 pt-5 pb-2 rounded-xl relative scale-75  bg-[#0ea5e9]'> */}
            {/* <div className='w-44 h-36 shadow-md shadow-blue-500 pt-5 pb-2 rounded-xl relative scale-75  bg-[#0000ff10]'> */}

            <div className='-rotate-90 absolute -left-[57px] top-[4.7rem] w-28 h-[7px]'>
                <progress className={`progress bg-black ${skill < 50 ? 'progress-error' : skill < 60 ? 'progress-warning' : 'progress-success'}`} value={animation < skill ? animation : skill} max="100"></progress>
                <small className={`text-[11px] font-extralight absolute left-4 top-5 ${skill < 50 ? 'text-error' : skill < 60 ? 'text-warning' : 'text-success'}`}>Progess ( {animation < skill ? animation : skill} ) %</small>
            </div>
            <div className='flex flex-col items-center justify-center' data-aos="fade" data-aos-duration="2000">
                <language.icon></language.icon>
                <small className='mt-5 font-play'>{name}</small>
            </div>
        </div>
    );
};

export default Skill;